export type HomeHeroCardExtraPair = { key?: string; value?: string };

export function extrasToPairs(
  extras: Record<string, string> | null | undefined,
): HomeHeroCardExtraPair[] {
  if (!extras) {
    return [];
  }
  return Object.entries(extras).map(([key, value]) => ({ key, value }));
}

export function pairsToExtras(
  pairs: HomeHeroCardExtraPair[] | undefined,
): Record<string, string> {
  const extras: Record<string, string> = {};
  for (const pair of pairs ?? []) {
    const key = pair.key?.trim() ?? "";
    const value = pair.value ?? "";
    if (!key && !value) {
      continue;
    }
    extras[key] = value;
  }
  return extras;
}

export function extraPairsError(
  pairs: HomeHeroCardExtraPair[] | undefined,
): string | null {
  const seen = new Set<string>();
  for (const pair of pairs ?? []) {
    const key = pair.key?.trim() ?? "";
    const value = pair.value ?? "";
    if (!key && !value) {
      continue;
    }
    if (!key) {
      return "Extras keys cannot be empty";
    }
    if (seen.has(key)) {
      return `Duplicate extras key: ${key}`;
    }
    seen.add(key);
  }
  return null;
}
